import React, { useEffect, useState } from 'react';
import {
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Box,
    Center,
    Text,
    Spinner,
    Flex
} from '@chakra-ui/react';

import Otp from './OTP';
import Transactions from './Transaction';
import { fetchWrapper } from '../../helpers';
import { LuSplit } from 'react-icons/lu';
import Header from '../../components/Header';
import PageHeading from '../../components/shared/PageHeading';
import usePagePermissions from '../../hooks/usePagePermissions';
import Informational from './Infromational/Informational';
import Marketing from './Marketing/Marketing';
import BoxWrapper from '../../components/BoxWrapper/BoxWrapper';

const RoutingMethods = ({ header }) => {
    const [activeTab, setActiveTab] = useState(0);

    const [channelList, setchannelList] = useState([])
    let user = JSON.parse(localStorage.getItem('customer'))
    const customer_id = user?.customer_id


    const { loading: permissionsLoading, can } = usePagePermissions('routing-methods');
    const [loading, setLoading] = useState(false);

    const routePermission = can("route-method")
    const routeMethodEditPermission = can("route-method-edit")
    useEffect(() => {
        if (permissionsLoading || !routePermission) return;

        loadChannelList()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [permissionsLoading, routePermission])

    const loadChannelList = async () => {
        setLoading(true)
        try {
            const url = `${process.env.REACT_APP_API_URL}/channel/list`;
            const data = await fetchWrapper.get(url)
            const listValue = data.data.map(cRs => {
                return { id: cRs.id, name: cRs.name }
            })

            setchannelList(listValue);
        } catch (error) {
            console.error('Error loading channel list:', error)
            setchannelList([])
        } finally {
            setLoading(false)
        }
    }


    const handleTabChange = (index) => {
        setActiveTab(index);
    };

    // Shared width for the pill tab bar and every card below it, so they
    // always end at exactly the same edge.
    const CONTENT_WIDTH = "800px";

    if (permissionsLoading || loading) {
        return (
            <>
                <Header />
                <BoxWrapper >
                    <Flex justify="center" align="center" h="300px">
                        <Spinner size="lg" />
                    </Flex>
                </BoxWrapper>
            </>
        );
    }
    return (
        <>
            <Header header={header} />
            <BoxWrapper >
                {routePermission ? <Box>
                    <PageHeading icon={LuSplit} title="Routing Methods" subtitle="Configure how notifications are routed for each message type." mb={5} />
                    <Tabs variant="unstyled" onChange={handleTabChange} isLazy>
                        <TabList bg="#f1f5f9" p="1" borderRadius="full" gap={1} w={CONTENT_WIDTH} maxW="100%" overflowX="auto" overflowY="hidden">
                            {['OTP', 'Transactions', 'Marketing', 'Informational'].map((label) => (
                                <Tab
                                    key={label}
                                    flex={1}
                                    px={4}
                                    py={1.5}
                                    borderRadius="full"
                                    fontSize="sm"
                                    fontWeight="500"
                                    color="gray.500"
                                    whiteSpace="nowrap"
                                    transition="all 0.15s"
                                    _hover={{ color: 'gray.700' }}
                                    _selected={{ bg: 'white', color: 'gray.800', fontWeight: '600', boxShadow: 'sm' }}
                                >
                                    {label}
                                </Tab>
                            ))}
                        </TabList>
                        <TabPanels>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Otp customer_id={customer_id} channelData={channelList} message_type_id={1} num={Math.random()} editPermission={routeMethodEditPermission} />
                                </Box>
                            </TabPanel>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Transactions customer_id={customer_id} message_type_id={2} channelData={channelList} editPermission={routeMethodEditPermission} />
                                </Box>
                            </TabPanel>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Marketing customer_id={customer_id} message_type_id={3} channelData={channelList} editPermission={routeMethodEditPermission} />
                                </Box>
                            </TabPanel>
                            <TabPanel px={0} pt={5}>
                                <Box className="box-style-card" w={CONTENT_WIDTH} maxW="100%" bg="white">
                                    <Informational customer_id={customer_id} message_type_id={4} channelData={channelList} editPermission={routeMethodEditPermission} />
                                </Box>
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </Box> : <Box className='card-style'>
                    <Center h="400px">
                        <Box textAlign="center">
                            <Text fontSize="xl" fontWeight="semibold" color="gray.700" mb={2}>
                                No Access
                            </Text>
                            <Text fontSize="sm" color="gray.500">
                                You don't have permission to view this sections.
                            </Text>
                        </Box>
                    </Center>
                </Box>}

            </BoxWrapper>
        </>

    )
}
export default RoutingMethods